import { render, staticRenderFns } from "./CPDueDiligenceReminderOverview.vue?vue&type=template&id=77037fb2&scoped=true&"
import script from "./CPDueDiligenceReminderOverview.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceReminderOverview.vue?vue&type=script&lang=ts&"
import style0 from "./CPDueDiligenceReminderOverview.vue?vue&type=style&index=0&id=77037fb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77037fb2",
  null
  
)

export default component.exports